import { fetchRoles, fetchRole, createRole, updateRole, deleteRole } from '@/api/roles'
import { Commit } from 'vuex'
import { RolesState } from '../state'

const emptyRoleObject = {
  name: '',
  permissions: []
}

const rolesStore = {
  state: {
    list: [],
    edit: {
      id: null,
      name: '',
      permissions: []
    },
    create: Object.assign({}, emptyRoleObject)
  },
  getters: {
    rolesList: (state: RolesState )=> {
      return state.list
    },
    roleEdit: (state: RolesState )=> {
      return state.edit
    },
    roleCreate: (state: RolesState )=> {
      return state.create
    }
  },
  mutations: {
    'roles.setListTo': (state: RolesState, payload: any) => {
      state.list = payload
    },
    'roles.setEditTo': (state: RolesState, payload: any) => {
      state.edit = payload
    },
    'roles.editPermissionsInput': (state: RolesState, payload: any) => {
      state.edit.permissions = payload
    },
    'roles.editNameInput': (state: RolesState, payload: any) => {
      state.edit.name = payload
    },
    'roles.createUpdateInput': (state: RolesState, payload: any) => {
      const create: {[key: string]: any} = state.create
      create[payload.name] = payload.value
    },
    'roles.createClear': (state: RolesState) => {
      state.create = Object.assign({}, emptyRoleObject)
    },
    'roles.deleteById': (state: RolesState, payload: any) => {
      state.list = state.list.filter((role: any) => {
        return String(role.id) !== String(payload.id)
      })
    }
  },
  actions: {
    'roles.fetch': ({ commit }: {commit : Commit}) => {
      return fetchRoles().then((res) => {
        commit('roles.setListTo', res.data)
      })
    },
    'roles.getSingleForEdit': ({ commit }: {commit : Commit}, id: any) => {
      return fetchRole(id).then((role) => {
        commit('roles.setEditTo', role.data)
      })
    },
    'roles.updateRole': ({ state }: { state: RolesState}) => {
      return updateRole(state.edit.id, { name: state.edit.name, permissions: state.edit.permissions })
    },
    'roles.create': ({ commit, state }: { commit : Commit, state: RolesState}) => {
      return createRole(state.create).then((res) => {
        commit('roles.createClear')
        return res.data.id
      })
    },
    'roles.delete': ({ commit }: { commit : Commit}, id: any) => {
      return deleteRole(id).then(() => {
        commit('roles.deleteById', { id: id })
      })
    }
  }
}

export default rolesStore
